import { Card, CompartmentCard } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { FolderItem, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, uid } from "@/src/utils/utils";
import { useState } from "react";
import { MesureChartDrawer } from "./mesuresChart";
import { openMesureInputs } from "./mesuresInputs";
import { USER } from "@/src/data/globalVariables";

function MesuresHistory({
  parent,
  patient,
}: {
  parent: FolderItem | null | undefined;
  patient: Patient;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  return (
    <CompartmentCard
      title={"Mesures"}
      color="red"
      onClick={async () => {
        await openMesureInputs({
          patient,
          parent: null,
          onConfirm: async (mesures) => {
            setReload((prev) => prev + 1);
          },
        });
      }}
    >
      <FetchableList
        queryKey={["MesuresHistory", searchKey, patient.id, reload]}
        queryFn={() =>
          apiFetch("patientMesures", "loadPatientLastMesures", {
            patientId: patient.id,
            parentId: getItemId(parent),
          })
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((mesure, index) => {
              return (
                <StaggeredAnimation key={uid()} index={index}>
                  <Card
                    title={mesure.reference?.name}
                    color="red"
                    onClick={async () => {
                      if (!mesure.reference) return;
                      let isWeight = mesure.reference.name
                        ?.toLowerCase()
                        .includes("poids");
                      let isHeight = mesure.reference.name
                        ?.toLowerCase()
                        .includes("taille");

                      let weightReference =
                        USER.get()?.speciality?.frequentReferences?.find(
                          (ref) => ref?.name?.toLowerCase().includes("poids")
                        );
                      let heightReference =
                        USER.get()?.speciality?.frequentReferences?.find(
                          (ref) => ref?.name?.toLowerCase().includes("taille")
                        );

                      await openDrawer({
                        id: "mesuresChartDrawer",
                        title: "Historique des mesures",
                        additionalClasses: ["medium"],

                        content: (
                          <div className="c1 gap10">
                            <MesureChartDrawer
                              parent={parent}
                              patient={patient}
                              reference={mesure.reference}
                              additionalHtml={
                                <div>
                                  {isWeight && heightReference && (
                                    <div>
                                      <MesureChartDrawer
                                        parent={parent}
                                        patient={patient}
                                        reference={heightReference}
                                        showMesuresList={false}
                                      />
                                    </div>
                                  )}
                                  {isHeight && weightReference && (
                                    <div>
                                      <MesureChartDrawer
                                        parent={parent}
                                        patient={patient}
                                        reference={weightReference}
                                        showMesuresList={false}
                                      />
                                    </div>
                                  )}
                                </div>
                              }
                            />
                          </div>
                        ),
                        footer: <div></div>,
                      });
                    }}
                  >
                    <div className="grid c1 ">
                      {mesure.fieldAnswers?.map((answer) => {
                        return (
                          <div key={uid()} className="bold">
                            {answer?.value} {answer?.field?.unit?.name || ""}
                          </div>
                        );
                      })}
                    </div>
                  </Card>
                </StaggeredAnimation>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}

export { MesuresHistory };
